<template>
  <div v-if="Object.keys(content).length !== 0">
    <h1 v-html="content.StepOne.LabelSectionTitle" />
    <section>
      <article class="flow-group">
        <div class="control">
          <div class="control row">
            <div class="small-12 columns">
              <h-3-and-tooltip
                :h3="content.StepOne.LabelYouCanBecomeAMemberIfText"
                :tooltip="content.StepOne.TooltipYouCanBecomeAMemberIfText"
              />
              <Field
                name="studentType"
                :rules="'required'"
                :label="content.StepOne.FieldNameYouCanBecomeAMemberIf"
                :model-value="localModel.studentType"
              >
                <VueSelect
                  v-if="studentTypes.length > 0"
                  :model-value="localModel.studentType"
                  :options="studentTypes"
                  label="LabelStudentType"
                  name="studentType"
                  @update:model-value="
                    localModel.studentType = $event;
                    handleStudentTypeChange(localModel.studentType);
                  "
                />
              </Field>
              <ValidationError
                name="studentType"
                :overrides="{ required: content.Shared.LabelGenericErrorMessage }"
              />
            </div>
          </div>

          <fieldset v-if="!isEmpty(localModel.StudentMemberOrganization) && !showStudyExtraAutomaticallyInfobox" class="checkbox-inline">
            <Field
              id="StudentMemberOrganization"
              :model-value="studyInsuranceSubmitTemplate.IsStudyExtra"
              :rules="{ required: studentMemberOrganizationRequired }"
              name="StudentMemberOrganization"
              type="checkbox"
              :value="true"
              :unchecked-value="false"
              @update:model-value="
                studyInsuranceSubmitTemplate.IsStudyExtra = $event;
                emitStudyExtraChange($event);
              "
            />
            <LabelAndTooltip
              for="StudentMemberOrganization"
              :label="studyExtraLabelText"
              :tooltip="content.StepOne.TooltipStudyExtraRequiredAdditional"
            />
            <LabelAndTooltip
              v-if="studentMemberOrganizationRequired"
              for="StudentMemberOrganization"
              :label="sitecoreInputWithCodeFix(content.StepOne.TooltipStudyExtraRequiredAdditional)"
            />
          </fieldset>
          <ValidationError
            name="StudentMemberOrganization"
            :overrides="{ required: content.Shared.LabelGenericErrorMessage }"
          />

          <div v-if="showStudyExtraAutomaticallyInfobox" class="basic-info-study__study-extra-info-box" v-html="textStudyExtraIsAutomaticallyIncluded" />
        </div>

        <div class="control">
          <h3 v-html="content.StepOne.LabelAge" />
          <Field
            id="Age"
            :model-value="studentAge"
            :rules="'required|numeric|min:2|max:2|min_value:18|max_value:29'"
            type="text"
            name="Age"
            max="2"
            :label="content.StepOne.LabelAge"
            autocomplete="off"
            @blur="studentAge = $event.target._value"
          />
          <ValidationError
            name="Age"
            :overrides="{ required: content.Shared.LabelErrorMessageCantFindAge, max_value: errorLabelStudentAge }"
          />
        </div>

        <div class="control">
          <h3 v-html="content.StepOne.LabelAndTooltipZip" />
          <Field
            id="PostalCode"
            v-model.lazy="studyInsuranceSubmitTemplate.Zip"
            :rules="'required|numeric|min:4|max:4|validate_postalcode'"
            type="text"
            name="PostalCode"
            max="4"
            :label="content.StepOne.LabelAndTooltipZip"
            data-vv-validate-on="blur"
            autocomplete="off"
            @input="emitZipChange($event.target.value)"
          />
          <ValidationError
            name="PostalCode"
            :overrides="{ required: content.Shared.LabelErrorMessageCantFindZip }"
          />
        </div>
      </article>
    </section>
  </div>
</template>
<script>
import { isEmpty } from 'lodash';
import StudyMixin from './StudyMixin.vue';
import VueSelect from '@/components/UI/VueSelect.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';

export default {
  name: 'BasicInfoStudy',
  components: {
    H3AndTooltip,
    VueSelect,
    ValidationError
  },
  emits: ['zipchange', 'studyextrachange', 'showstdstopmodal', 'update:modelValue'],
  mixins: [StudyMixin],
  props: {
    content: {
      type: Object,
      default() {
        return {};
      }
    },
    modelValue: {
      type: Object,
      default() {
        return {};
      }
    },
    localModel: {
      type: Object,
      default() {
        return {
          studentMemberOrganizationRequired: false
        };
      }
    }
  },
  data() {
    return {
      model: {},
      studentMemberOrganizationRequired: false,
      studentMemberOrganizationRequiredShowAltText: false,
      StudentMemberOrganization: null,
      studentAge: null,
      textStudyExtraIsAutomaticallyIncluded: '',
    };
  },
  computed: {
    studyInsuranceSubmitTemplate: {
      get() {
        if (Object.prototype.hasOwnProperty.call(this.modelValue, 'Data')) {
          return this.modelValue.Data.StudyInsuranceSubmitTemplate;
        }
        return {};
      },
      set(val) {
        const tmp = { ...this.modelValue };
        tmp.Data.StudyInsuranceSubmitTemplate = val;
        this.$emit('update:modelValue', tmp);
      }
    },
    studentTypes() {
      if (Object.prototype.hasOwnProperty.call(this.modelValue, 'Content')) {
        return this.modelValue.Content.StepOne.StudentTypes;
      }
      return [];
    },
    studyExtraLabelText() {
      const TextRequiredOrganization = this.sitecoreInputWithCodeFix(
        this.content.StepOne.LabelStudyExtraAdditional
      );
      const textRequiredOrganizationAlt = this.localModel.studentType.TextRequiredOrganization;
      return textRequiredOrganizationAlt !== ''
        ? textRequiredOrganizationAlt
        : TextRequiredOrganization;
    },
    showStudyExtraAutomaticallyInfobox() {
      return this.localModel.studentType?.CheckboxStudyExtraIsAutomaticallyIncluded;
    },
    errorLabelStudentAge() {
      return this.content.Shared.LabelErrorStudentAge !== ''
        ? this.content.Shared.LabelErrorStudentAge
        : 'Alder må maximum være 29';
    }
  },
  watch: {
    'localModel.studentType': function (val) {
      this.handleStudentTypeChange(val);
    },
    'studyInsuranceSubmitTemplate.IsStudyExtra': function (val) {
      if (val) {
        this.studyInsuranceSubmitTemplate.StudentMemberOrganization =
          this.localModel.StudentMemberOrganization;
      } else {
        this.studyInsuranceSubmitTemplate.StudentMemberOrganization = null;
      }
    },
    'studyInsuranceSubmitTemplate.Zip': function (val) {
      if (val) {
        this.studyInsuranceSubmitTemplate.Address = null;
        this.localModel.address = null;
      }
    },
    studentAge(age) {
      if (age > 29 || age < 18) {
        this.$emit('showstdstopmodal');
      }
    }
  },
  mounted() {
    this.selectMembershipAndOrganization();
  },
  methods: {
    handleStudentTypeChange(studentType) {
      this.studyInsuranceSubmitTemplate.IsStudyExtra = studentType.CheckBoxStudyExtraIsPreselected || studentType.CheckboxStudyExtraIsAutomaticallyIncluded;
      this.studyInsuranceSubmitTemplate.StudentType = studentType.LabelStudentType;
      this.studyInsuranceSubmitTemplate.ConsentToContactMemberOrganizationIsNotRequired =
        studentType.CheckboxOrganizationConsentIsNotRequired;
      this.localModel.StudentMemberOrganization = studentType.LabelRequiredOrganizationName;
      this.studentMemberOrganizationRequired = studentType.CheckboxOrganizationIsRequired;
      this.studentMemberOrganizationRequiredShowAltText =
        studentType.TextRequiredOrganization !== '';
      this.StudentMemberOrganization = studentType.LabelRequiredOrganizationName;
      this.textStudyExtraIsAutomaticallyIncluded = this.studyExtraAutomaticallyInfoboxText(studentType);
    },
    selectMembershipAndOrganization() {
      const vm = this;
      const preselectedMembershipType = vm.getQueryParameter('MemberType');
      const isMembershipTypePreselected =
        preselectedMembershipType !== undefined && preselectedMembershipType !== '';

      if (isMembershipTypePreselected) {
        vm.localModel.studentType = vm.studentTypes.find(
          (studentType) => studentType.LabelStudentTypeUrlParameter === preselectedMembershipType
        );

        if (vm.localModel.studentType !== undefined && vm.localModel.studentType !== null) {
          this.handleStudentTypeChange(vm.localModel.studentType);
        }
      }
    },
    getQueryParameter(queryParameterKey) {
      const uri = window.location.href.split('?');
      let result = '';
      if (uri.length == 2) {
        const vars = uri[1].split('&');
        vars.forEach((v) => {
          const keyValuePair = v.split('=');
          if (keyValuePair.length == 2) {
            if (keyValuePair[0] === queryParameterKey) {
              result = keyValuePair[1];
            }
          }
        });
      }
      return result;
    },
    sitecoreInputWithCodeFix(sitecoreInput) {
      var splitLabel = sitecoreInput.split('{{StudentMemberOrganization}}');
      if (splitLabel.length > 1) {
        return splitLabel[0] + this.localModel.StudentMemberOrganization + splitLabel[1];
      }
      return sitecoreInput;
    },
    studyExtraAutomaticallyInfoboxText(studentType) {
      if (studentType.TextStudyExtraIsAutomaticallyIncluded.length) {
        return studentType.TextStudyExtraIsAutomaticallyIncluded;
      }
      
      return `<p><strong>Du har s&aelig;rlige fordele</strong></p><p>Som medlem af ${studentType.LabelStudentType} f&aring;r du automatisk Studieforsikring EKSTRA, der giver dig en lang r&aelig;kke fordele.</p>`;
    },
    emitZipChange(val) {
      this.$emit('zipchange', val);
    },
    emitStudyExtraChange(val) {
      this.$emit('studyextrachange', val);
    },
    isEmpty
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/all';
@import 'src/styles/colors.scss';
@import 'src/styles/typography/_icons.scss';

.basic-info-study {
  &__study-extra-info-box {
    background-color: $body-background;
    margin-bottom: rem-calc(16px);
    padding: rem-calc(16) rem-calc(16) rem-calc(16) rem-calc(88);
    position: relative;

    &:before {
      font-family: $icon;
      content: '\e905';
      height: rem-calc(56);
      width: rem-calc(56);
      background-color: $color-success-background;
      border-radius: 50%;
      position: absolute;
      left: rem-calc(16);
      top: rem-calc(16);

      display: flex;
      align-items: center;
      justify-content: center;
      font-size: rem-calc(18);
      color: $color-success-text;
    }
  }
}
</style>
